import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiMutation } from '../../../../common/model/api.mutation';

export interface MarkUserModuleDescriptionAsVisualizedParams {
	readonly coachingPlanModuleId: string;
}

@Injectable({ providedIn: 'root' })
export class MarkUserModuleDescriptionAsVisualizedApiMutation extends ApiMutation<
	string,
	MarkUserModuleDescriptionAsVisualizedParams
> {
	client = 'content';
	document = gql`
		mutation MarkUserModuleDescriptionAsVisualised($coachingPlanModuleId: UUID!) {
			markUserModuleDescriptionAsVisualised(
				coachingPlanModuleId: $coachingPlanModuleId
			)
		}
	`;
	method = 'markUserModuleDescriptionAsVisualised';
}
